import { Card, Flex } from "antd";

import {
  DeficientProjects,
  ProjectsInCloseoutStage,
} from "projects/components";
import {
  IDeficientProject,
  IProjectInCloseoutStage,
} from "projects/models";
import variables from "../../../../../_variables.scss";

type Props = {
  loading?: boolean;
  deficientProjects?: IDeficientProject[];
  projectsInCloseoutStage?: IProjectInCloseoutStage[];
};

export const OperationsManagerDashboardProjectsCard = ({
  loading,
  deficientProjects,
  projectsInCloseoutStage,
}: Props) => {
  return (
    <Card
      loading={loading}
      bordered={false}
      data-testid='operationsManagerDashboardProjectsCard'
    >
      <Flex vertical gap={variables.gap}>
        <ProjectsInCloseoutStage projectsInCloseoutStage={projectsInCloseoutStage ?? []} />
        <DeficientProjects deficientProjects={deficientProjects ?? []} />
      </Flex>
    </Card>
  );
};
